<mwl-calendar-month-view
  class="days"
  [viewDate]="displayDate"
  [events]="events"
  [cellTemplate]="dayTemplate"
  [weekStartsOn]="firstDayOfWeek()"
  [refresh]="displayZoneRefresh"
  (resize)="handleResize()"
  resizeDelayType="throttle"
/>

<ng-template
  #dayTemplate
  let-day="day"
>
  <stch-calendar-month-day-cell
    #dayRef
    [day]="day"
    [selected]="day.date | sameDisplayDay : selectedDate : displayTimeZone"
    [popupDisabled]="contextMenuOpened"
    [eventsAppearance]="eventsAppearance"
    [maxEventsPerCell]="maxEventsPerCell"
    class="h-full"

    (eventClicked)="eventClicked.emit($event)"
    (eventDblClicked)="eventDblClicked.emit($event)"

    (appClick)="day.inMonth && selectCalendarDate($event, day.date, dayRef.elementRef.nativeElement)"
    (appDblClick)="day.inMonth && dblClickCalendarDate(day.date)"

    appDroppable
    appDroppableHoverClass="drag-over"
    (appDroppableDrop)="handleDrop($event, day.date, dayRef.elementRef.nativeElement)"

    [appCalendarCellContextMenu]="day.date"
    [appCalendarCellContextMenuCalendarType]="CalendarType.MONTH"
    (stchPopoverVisibleChange)="contextMenuOpened = $event"
  />
</ng-template>
